import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IccPharmacyImportsService } from 'app/core/services/icc/icc-pharmacy-imports.service';
import { ImportUploadResult, IccImportUploadComponent } from '../../components/icc-import-upload/icc-import-upload.component';
import { HttpErrorResponse } from '@angular/common/http';
import { isEmpty } from 'lodash-es';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';


@Component({
    selector: 'app-icc-import-pharmacies',
    templateUrl: './icc-import-pharmacies.component.html',
    styleUrls: ['./icc-import-pharmacies.component.scss'],
    imports: [ImportNavComponent, IccImportUploadComponent]
})
export class IccImportPharmaciesComponent {
  private pharmacyImportsService = inject(IccPharmacyImportsService);
  private router = inject(Router);

  errors: string[] = [];

  onUploadComplete({ clientId, name, upload }: ImportUploadResult) {
    this.pharmacyImportsService.create(clientId, name, upload.signedId).subscribe(
      () => {
        this.router.navigate(['/capture-admin/icc-claims/imports/pharmacies/history']);
      },
      (error: HttpErrorResponse) => {
        this.errors = error.error.errors;
      }
    );
  }

  onUploadStart() {
    this.errors = [];
  }

  public get hasError() {
    return !isEmpty(this.errors);
  }
}
